import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConversionProjectViewModel as ConversionProjectPageTexts } from '../../types/ConversionProject';

interface ConversionProjectState {
  pageTexts: ConversionProjectPageTexts | undefined;
  id: string;
  searchTerm: string;
}

export const initialState: ConversionProjectState = {
  pageTexts: undefined,
  id: '',
  searchTerm: '',
};

const conversionProjectSlice = createSlice({
  name: 'conversionProject',
  initialState,
  reducers: {
    setPageTexts(state, action: PayloadAction<ConversionProjectPageTexts>) {
      return { ...state, pageTexts: action.payload };
    },
    setId(state, action: PayloadAction<string>) {
      return { ...state, id: action.payload };
    },
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload.trim();
    },
  },
});

export const { setSearchTerm, setId, setPageTexts } =
  conversionProjectSlice.actions;

export default conversionProjectSlice.reducer;
